import React from "react";
import { Link } from "react-router-dom";
import partners from "../../assets/partners.png";
import { IoLogoYoutube } from "react-icons/io5";
import { FaInstagram } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { TiSocialLinkedin } from "react-icons/ti";
import { FaMapMarkerAlt } from "react-icons/fa";
import { GoClockFill } from "react-icons/go";
import { FaPhone } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="bg-dark text-white pt-5">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-4">
            <div
              className="footer-highlight p-4 rounded-3"
              style={{ backgroundColor: "#3a3a3a" }}
            >
              <div className="text-center mb-4">
                <img
                  src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/08/New-Logo-Elite-Body-Homej-04-large.png"
                  alt="Logo"
                  className="img-fluid"
                  width="200"
                  height="80"
                  style={{ maxWidth: "200px" }}
                />
              </div>

              <ul className="list-unstyled footer-contact">
                <li className="mb-3 d-flex align-items-start">
                  <GoClockFill className="mt-1 me-3 fs-6" />
                  <span>Monday - Sunday, 9:00 AM - 9:00 PM</span>
                </li>
                <li className="mb-3 d-flex align-items-start">
                  <div className="d-flex align-items-start">
                    <FaMapMarkerAlt
                      className="me-3"
                      style={{
                        fontSize: "16px",
                        flexShrink: 0,
                        marginTop: "4px",
                      }}
                    />
                    <p className="mb-0">
                      2nd December Street, Jumeirah 1, Al Hudaiba Awards
                      Buildings Block B, 117, 1st Floor - Dubai
                    </p>
                  </div>
                </li>

                <li className="mb-3 d-flex align-items-start">
                  <FaPhone className="mt-1 me-3 fs-6" />
                  <span>+971 55 120 0086</span>
                </li>
                <li className="mb-3 d-flex align-items-start">
                  <FaPhone className="mt-1 me-3 fs-6" />
                  <span>+971 4 547 9492</span>
                </li>
              </ul>

              <div className="social-icons d-flex justify-content-center gap-3 mt-4">
                <Link
                  to="https://youtube.com/@elitebodyhome"
                  className="text-white bg-primary rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: "40px", height: "40px" }}
                >
                  <IoLogoYoutube className="fs-4" />
                </Link>
                <Link
                  to="https://www.instagram.com/elitebodyhomeuae?igsh=dTFnbmFobW5lODNk"
                  className="text-white bg-primary rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: "40px", height: "40px" }}
                >
                  <FaInstagram className="fs-4" />
                </Link>
                <Link
                  to="https://www.facebook.com/elitebodyhomeuae"
                  className="text-white bg-primary rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: "40px", height: "40px" }}
                >
                  <FaFacebookF className="fs-4" />
                </Link>
                <Link
                  to="https://www.linkedin.com/company/elite-body-home-poly-clinic-l-l-c/posts/?feedView=all"
                  className="text-white bg-primary rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: "40px", height: "40px" }}
                >
                  <TiSocialLinkedin className="fs-4" />
                </Link>
              </div>
            </div>
          </div>

          {/* Services Column */}
          <div className="col-lg-2 col-md-4">
            <div className="p-3">
              <h5 className="text-uppercase mb-4" style={{ color: "#c69933" }}>
                Services
              </h5>
              <div className="list-unstyled footer-links">
                <div className="mb-2">
                  <Link to="#" className="text-white text-decoration-none">
                    Aesthetics
                  </Link>
                </div>
                <div className="mb-2">
                  <Link to="#" className="text-white text-decoration-none">
                    Weightloss & Slimming
                  </Link>
                </div>
                <div className="mb-2">
                  <Link to="#" className="text-white text-decoration-none">
                    IV Drip
                  </Link>
                </div>
                <div className="mb-2">
                  <Link to="#" className="text-white text-decoration-none">
                    Laser Hair Removal
                  </Link>
                </div>
                <div className="mb-2">
                  <Link to="#" className="text-white text-decoration-none">
                    Dental
                  </Link>
                </div>
                <div className="mb-2">
                  <Link to="#" className="text-white text-decoration-none">
                    Physiotherapy
                  </Link>
                </div>
                <div className="mb-2">
                  <Link to="#" className="text-white text-decoration-none">
                    Urology
                  </Link>
                </div>
                <div className="mb-2">
                  <Link to="#" className="text-white text-decoration-none">
                    Homecare
                  </Link>
                </div>
                <div className="mb-2">
                  <Link to="#" className="text-white text-decoration-none">
                    Lab Tests
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links Column */}
          <div className="col-lg-2 col-md-4">
            <div className="p-3">
              <h5 className="text-uppercase mb-4" style={{ color: "#c69933" }}>
                Quick Links
              </h5>
              <ul className="list-unstyled footer-links">
                <li className="mb-2">
                  <Link to="/home" className="text-white text-decoration-none">
                    Home
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/blog" className="text-white text-decoration-none">
                    Blog
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="#" className="text-white text-decoration-none">
                    Services
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/contact"
                    className="text-white text-decoration-none"
                  >
                    Contact us
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="https://ebhacademy.com"
                    className="text-white text-decoration-none"
                  >
                    Training
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Partners Column */}
          <div className="col-lg-4 col-md-4">
            <div className="p-3">
              <h5 className="text-uppercase mb-4" style={{ color: "#c69933" }}>
                Our Partners
              </h5>
              <div className=" rounded-3 d-flex justify-content-center">
                <img
                  src={partners}
                  alt="Our Partners"
                  className="img-fluid"
                  width="250"
                  height="150"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="bg-black py-2">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p
                className="text-center"
                style={{ fontSize: "11px", marginBottom: "0px" }}
              >
                <small>
                  This advertisement permission was granted by MOH based on the
                  professional/activity licenses for both advertising facility
                  and its healthcare providers who should deliver the
                  service/products in accordance with the regulations and
                  standards set by the licensing authority. MOH is ABSOLUTELY
                  NOT part of this deal or any of its terms. Buying the deal is
                  exclusively the responsibility of the consumer. <br />
                  <strong>MOH License Number:</strong> 9ZJSI25F-180724
                </small>
              </p>

              <p
                className="small text-center"
                style={{ fontSize: "11px", marginBottom: "0px" }}
              >
                <small>
                  <strong>Disclaimer:</strong> Results May Vary: The results of
                  treatments provided by our polyclinic may vary depending on
                  individual circumstances, medical history, and other factors.
                  While we strive to provide the best possible care and
                  treatment, results will depend on several factors for each
                  individual. The treatments/package can be modified as per the
                  individual assessment during consultation to incorporate these
                  conditions.
                </small>
              </p>

              <p
                className="text-center text-gold mb-0"
                style={{ color: "#c69933" }}
              >
                Copyright © 2024 ELITE BODY HOME POLYCLINIC LLC – All Rights
                Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
